import React from "react";
import { Button, required, TextInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import { scholarshipRequests } from "api/scholarshipApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const DisqualifyDialog = ({ studentEducationId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    const payload = {
      studentEducationId,
      orderNumber: data.orderNumber,
      orderDate: data.orderDate,
    };
    await dataProvider.customRequest(scholarshipRequests.blacklistScholarshipApplication(), payload, "POST");
    refresh();
    notify("Успешен отказ на заявка за стипендия на студента!", { type: "success" });
  };

  return (
    <FormModal
      titleContent={"Отказ на заявка за стипендия на студента!"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          startIcon={<DoDisturbOnIcon />}
          size="small"
          label="Откажи"
          color="error"
          variant="contained"
        />
      }
    >
      <TextInput
        source="orderNumber"
        label="Номер на заявка"
        validate={required()}
      />
      <CustomDateInput
        source="orderDate"
        label="Дата на заявка"
        noTime
        validate={required("Задължително")}
      />
    </FormModal>
  );
};

export default DisqualifyDialog;
